import React from 'react';
import logoSrc from '../assets/skoolweb-logo.png';

const VARIANTS = {
  header: { height: 56, className: 'skoolweb-logo--header' },
  footer: { height: 52, className: 'skoolweb-logo--footer' },
  avatar: { height: 72, className: 'skoolweb-logo--avatar' },
};

const SkoolWebLogo = ({ variant = 'header', className = '', alt = 'SkoolWeb logo', style = {} }) => {
  const config = VARIANTS[variant] || VARIANTS.header;

  return (
    <img
      src={logoSrc}
      alt={alt}
      className={`skoolweb-logo ${config.className} ${className}`.trim()}
      style={{
        height: config.height,
        width: 'auto',
        maxWidth: '100%',
        objectFit: 'contain',
        display: 'block',
        flexShrink: 0,
        ...style,
      }}
      decoding="async"
    />
  );
};

export default SkoolWebLogo;
